import axios from 'axios';

// The API endpoint to validate the access_key
export const validateAccessKeyAPI = async (baseUrl: string, program_id: number, access_key: string, events: number[]) => {
  try {
    const event_ids = encodeURIComponent(events.join(','))
    const response = await axios.get(`${baseUrl}/api/custom/validate/accesskey/?access_key=${access_key}&program=${program_id}&events=${event_ids}`);
    return response.data === true; // Assuming the API returns { isValid: true/false }
  } catch (error) {
    throw new Error('API request failed');
  }
};